import type { IExtractParams } from "@/routes";
import { apiPathFunc } from "@api/util/apiPathFunc";

const pathBase = `/course-enrollments/`;
const pathById = `${pathBase}:enrollmentId/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;
export type IPathByIdParam = IExtractParams<typeof pathById>;

export const enrollments = {
  getAll: apiPathFunc(pathBase),
  post: apiPathFunc(pathBase),
  get: apiPathFunc(pathById),
  patch: apiPathFunc(pathById),
} as const;
